import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { postRequest, putRequest } from '../../requestUtils';
import './ConsultantAgreementModal.scss';
import cloraLogo from '../../../assets/images/Logo_Gray.svg';

class ConsultantAgreementModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: props.showModal,
      agreeCheckbox: false,
    };

    this.handleToggleCheckbox = this.handleToggleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCallback = this.handleCallback.bind(this);
  }

  handleToggleCheckbox() {
    const { agreeCheckbox } = this.state;

    this.setState({ agreeCheckbox: !agreeCheckbox });
  }

  handleCallback() {
    const { submitUrl, submitMethod, csrfToken } = this.props;

    if (submitMethod === 'get') {
      this.setState({ showModal: false });
      window.location = submitUrl;
    } else {
      postRequest(submitUrl, {}, csrfToken, 'text').then((response) => {
        this.setState({ showModal: false });
        window.location = response.data.redirect_url;
      }).catch(() => {
        this.setState({ flashMessage: 'There was an error creating the proposal.' });
      });
    }
  }

  handleSubmit() {
    const { consultantProfileId, agreementVersion, csrfToken } = this.props;

    putRequest(
      `/consultant_profiles/${consultantProfileId}`,
      { signed_cra_version: agreementVersion },
      csrfToken,
    ).then(this.handleCallback).catch(() => {
      this.setState({ flashMessage: 'There was an error submitting the agreement.' });
    });
  }

  handleClose() {
    // Consultant does not agree
    const { cancelUrl } = this.props;

    this.setState({ showModal: false });
    if (cancelUrl) {
      window.location = cancelUrl;
    }
  }

  render() {
    const { showModal, agreeCheckbox, flashMessage } = this.state;
    const {
      agreementText, buttonText, buttonClass, buttonPrefix,
    } = this.props;

    return (
      <Fragment>
        { buttonText
          && (
          <a
            className={`cra-button ${buttonClass}`}
            onClick={() => this.setState({ showModal: true })}
            role="button"
            tabIndex={0}
            id="cra-modal"
          >
            <span dangerouslySetInnerHTML={{ __html: buttonPrefix }} />
            <span className="text-white">{buttonText}</span>
          </a>
          )}
        <Modal
          show={showModal}
          onHide={this.handleClose}
          dialogClassName="cra-confirm-modal"
          size="xl"
        >
          <Modal.Header closeButton />
          <Modal.Body className="style-guide padded-modal-content">
            <h2 className="mb-3">
              Clora Consultant Referral Agreement (CRA)
              <img
                src={cloraLogo}
                alt="clora logo"
                className="brand-img float-right"
                height={30}
                width={75}
              />
            </h2>
            {flashMessage}
            <div className="pt-3 body-text-2 agreement-text">
              <p dangerouslySetInnerHTML={{ __html: agreementText }} />
            </div>
            <label
              htmlFor="agree-checkbox"
              className="custom-checkbox-container agree-checkbox-label"
            >
              <input
                type="checkbox"
                id="agree-checkbox"
                onChange={this.handleToggleCheckbox}
              />
              <span className="checkmark" />
              <span className="label">
                Yes, I understand and agree to the Clora Consultant Referral Agreement
              </span>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <div className="button-container">
              <button
                className="btn btn-secondary button-back"
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary button-submit"
                onClick={this.handleSubmit}
                disabled={!agreeCheckbox}
              >
                Next
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

ConsultantAgreementModal.propTypes = {
  agreementText: PropTypes.string.isRequired,
  agreementVersion: PropTypes.string.isRequired,
  submitUrl: PropTypes.string.isRequired,
  submitMethod: PropTypes.string,
  cancelUrl: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonPrefix: PropTypes.string,
  consultantProfileId: PropTypes.string.isRequired,
};

ConsultantAgreementModal.defaultProps = {
  buttonText: null,
  buttonClass: '',
  buttonPrefix: '',
  showModal: false,
  cancelUrl: null,
  submitMethod: 'post',
};

export default ConsultantAgreementModal;
